<template>
  <div>
    <b-card
      :no-body="isCollapsed"
      v-if="question_kind == 1 || question_kind == 4"
    >
      <div slot="header">
        <div class="float-left">
          <b>{{ title }} </b>
          <span v-if="showInfo" v-b-tooltip.hover :title="tooltipText"
            ><i class="fa fa-lg fa-info-circle text-info"></i
          ></span>
        </div>
        <div class="float-right">
          <b-button
            v-if="allowCollapse"
            @click="isCollapsed = !isCollapsed"
            class="btn-success ml-2"
          >
            <span key="fa-chevron-down" v-if="isCollapsed"
              ><i class="fas fa-chevron-down"></i
            ></span>
            <span key="fa-chevron-up" v-else
              ><i class="fas fa-chevron-up"></i
            ></span>
          </b-button>
        </div>
      </div>
      <b-collapse :visible="!isCollapsed" class="mt-2">
        <b-col class="px-0">
          <b-row>
            <b-col cols="12" md="12">
              <b-alert show variant="info">
                <i class="fas fa-info-circle fa-lg mr-1" />
                <b v-html="displayModeAlertMessage" />
              </b-alert>
            </b-col>
            <b-col
              :class="
                display_mode_selected && display_mode_selected.value == 1
                  ? `col-12 col-md-6`
                  : `col-6`
              "
            >
              <b-form-group
                :label="$lang.azmoonLang.display_mode"
                label-for="display_mode"
                :label-cols="$config.azmoon.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.azmoonLang.display_mode"
                  :rules="$v.display_mode_selected.$params"
                />
                <selectFind
                  :options="display_mode_options"
                  v-model="$v.display_mode_selected.$model"
                  label="text"
                  id="value"
                  :isValid="
                    $v.display_mode_selected.$dirty
                      ? !$v.display_mode_selected.$error
                      : null
                  "
                  @input="changeDisplayMode"
                />
                <b-form-invalid-feedback
                  :style="{
                    display: $v.display_mode_selected.$error ? 'block' : 'none',
                  }"
                  id="display_mode_selected_feedback"
                >
                  {{
                    $lang.azmoonLang.error_required
                      | replace($lang.azmoonLang.display_mode)
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col
              :class="
                display_mode_selected && display_mode_selected.value == 1
                  ? `col-12 col-md-6`
                  : `col-6`
              "
            >
              <b-form-group
                :label="$lang.azmoonLang.option_show_kind"
                label-for="option_show_kind"
                :label-cols="$config.azmoon.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.azmoonLang.option_show_kind"
                  :rules="$v.show_kind_selected.$params"
                />
                <selectFind
                  :options="option_show_kind"
                  v-model="$v.show_kind_selected.$model"
                  label="text"
                  id="value"
                  :isValid="
                    $v.show_kind_selected.$dirty
                      ? !$v.show_kind_selected.$error
                      : null
                  "
                  :loading="option_show_kind_Loading"
                  @input="changeOptionShowKind"
                />
                <b-form-invalid-feedback
                  :style="{
                    display: $v.show_kind_selected.$error ? 'block' : 'none',
                  }"
                  id="show_kind_selected_feedback"
                >
                  {{
                    $lang.azmoonLang.error_required
                      | replace($lang.azmoonLang.option_show_kind)
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col
              v-if="display_mode_selected && display_mode_selected.value == 1"
              :class="
                display_mode_selected && display_mode_selected.value == 1
                  ? `col-12 col-md-6`
                  : `col-6`
              "
            >
              <b-form-group
                :label="$lang.azmoonLang.display_style"
                label-for="display_style"
                :label-cols="$config.azmoon.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.azmoonLang.display_style"
                  :rules="$v.status_selected.$params"
                />
                <selectFind
                  :options="status_options"
                  v-model="$v.status_selected.$model"
                  label="text"
                  id="value"
                  :isValid="
                    $v.status_selected.$dirty
                      ? !$v.status_selected.$error
                      : null
                  "
                  :loading="status_Loading"
                  @input="changeDisplayStyle"
                />
                <b-form-invalid-feedback
                  :style="{
                    display: $v.status_selected.$error ? 'block' : 'none',
                  }"
                  id="status_selected_feedback"
                >
                  {{
                    $lang.azmoonLang.error_required
                      | replace($lang.azmoonLang.display_style)
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col
              v-if="display_mode_selected && display_mode_selected.value == 1"
              :class="
                display_mode_selected && display_mode_selected.value == 1
                  ? `col-12 col-md-6`
                  : `col-6`
              "
            >
              <b-form-group
                :label="$lang.azmoonLang.col_number"
                label-for="col_number"
                :label-cols="$config.azmoon.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.azmoonLang.col_number"
                  :rules="$v.col_number_selected.$params"
                />
                <selectFind
                  :options="col_number_options"
                  v-model="$v.col_number_selected.$model"
                  label="text"
                  id="value"
                  :isValid="
                    $v.col_number_selected.$dirty
                      ? !$v.col_number_selected.$error
                      : null
                  "
                  :loading="col_number_Loading"
                  @input="changeColNumber"
                />
                <b-form-invalid-feedback
                  :style="{
                    display: $v.col_number_selected.$error ? 'block' : 'none',
                  }"
                  id="col_number_feedback"
                >
                  {{
                    $lang.azmoonLang.error_required
                      | replace($lang.azmoonLang.col_number)
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <div
            v-if="display_mode_selected && display_mode_selected.value == 1"
            :class="question_title ? `card_question` : ``"
          >
            <div v-html="question_title"></div>
            <b-col
              v-if="options && options.length > 0"
              class="w-100 question_line"
            ></b-col>
            <b-col
              v-if="options && options.length > 0"
              :class="`${
                status_selected && status_selected.value == 2 ? `p-0` : ``
              }`"
            >
              <div
                :class="
                  (status_selected && status_selected.value == 1) ||
                  (status_selected && status_selected.value == 3) ||
                  (status_selected && status_selected.value == 4)
                    ? `row my-3`
                    : `my-3`
                "
              >
                <optionchecked
                  itemId="0"
                  v-for="(option, index) in options"
                  :key="index"
                  :option="option"
                  ref="questionRef"
                  :col_number="col_number_selected && col_number_selected.value"
                  :option_show_kind="
                    show_kind_selected && show_kind_selected.value
                  "
                  :display_style="status_selected && status_selected.value"
                  @optionChecked="optionChecked"
                />
              </div>
            </b-col>
          </div>
          <div
            v-if="
              display_mode_selected &&
              display_mode_selected.value == 2 &&
              options.length > 0
            "
          >
            <lineOption
              :option_show_kind="show_kind_selected && show_kind_selected.value"
              :title="question_title"
              :options="options"
              class="m-0"
            />
          </div>
        </b-col>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { renderEumOptions, renderEumChildOptions } from "@/shared/utils";
import { pathOr } from "ramda";
import optionchecked from "./optionchecked";
import lineOption from "./lineOption";
import { required } from "vuelidate/lib/validators";

export default {
  name: "question-preview",
  validations: {
    show_kind_selected: {},
    status_selected: {},
    col_number_selected: {},
    display_mode_selected: {},
  },
  components: {
    optionchecked,
    lineOption,
  },
  props: {
    allowCollapse: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    question_title: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    showInfo: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      default: "",
    },
    question_kind: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      isCollapsed: false,
      selectedRadio: "first",
      selectedOption: null,
      option_show_kind: [],
      status_Loading: false,
      col_number_Loading: false,
      status_selected: null,

      display_mode_selected: null,
      col_number_selected: {
        text: "یک ستونی",
        value: "1",
      },
      col_number_options: [
        {
          text: "یک ستونی",
          value: "1",
        },
        {
          text: "دوستونی",
          value: "2",
        },
        {
          text: "سه ستونی",
          value: "3",
        },
        {
          text: "چهار ستونی",
          value: "4",
        },
        {
          text: "پنج ستونی",
          value: "5",
        },
        {
          text: "شش ستونی",
          value: "6",
        },
        {
          text: "هفت ستونی",
          value: "7",
        },
        {
          text: "هشت ستونی",
          value: "8",
        },
        {
          text: "نه ستونی",
          value: "9",
        },
        {
          text: "ده ستونی",
          value: "10",
        },
        {
          text: "یازده ستونی",
          value: "11",
        },
        {
          text: "دوازده ستونی",
          value: "12",
        },
      ],
      show_kind_selected: null,
      option_show_kind_Loading: false,
    };
  },
  computed: {
    display_mode_options() {
      return renderEumOptions("display_mode");
    },
    status_options() {
      return renderEumOptions("display_style");
    },
    displayModeAlertMessage() {
      return 'در صورتی که از گزینه‌های عکس دار استفاده می نمایید، باید مقدار "شکل گزینه‌ها" را از بین حالت‌هایی که عکس را نمایش می دهند انتخاب نمایید.';
    },
  },
  methods: {
    changeDisplayMode(item) {
      this.$emit("changeDisplayMode", item);
      this.getOptionShowKind();
    },
    async getOptionShowKind() {
      this.option_show_kind = renderEumChildOptions(
        pathOr(null, ["category_id"], this.display_mode_selected)
      );
      this.show_kind_selected = this.option_show_kind.find((x) => x.value == 9);
      if (this.show_kind_selected) {
        this.$emit("changeOptionShowKind", this.show_kind_selected);
      }
    },
    changeOptionShowKind(item) {
      this.$emit("changeOptionShowKind", item);
    },
    changeDisplayStyle(item) {
      this.$emit("changeDisplayStyle", item);
    },
    changeColNumber(item) {
      this.$emit("changeColNumber", item);
    },
    optionChecked(item, option, itemId) {
      let index = this.options.indexOf(option);
      this.$refs.questionRef.forEach((x) =>
        x.$el.childNodes[0].classList.remove("templateActive")
      );
      this.$refs.questionRef[index].$el.childNodes[0].classList.add(
        "templateActive"
      );
      this.options.map((x) => {
        if (x.id == option.id) {
          x.answer = true;
          return {
            ...x,
          };
        } else {
          x.answer = false;
          return {
            ...x,
          };
        }
      });
      if (event.target.checked == false) {
        this.$refs.questionRef.forEach((x) =>
          x.$el.classList.remove("templateActive")
        );
        this.options.map((x) => {
          x.answer = false;
          return {
            ...x,
          };
        });
      }
    },
    fetchData() {
      if (!this.id) {
        this.display_mode_selected = this.display_mode_options.find(
          (x) => x.value == 1
        );
        if (this.display_mode_selected) {
          this.$emit("changeDisplayMode", this.display_mode_selected);
        }
        this.getOptionShowKind();

        // this.getDisplayStyle();
        this.status_selected = this.status_options.find((x) => x.value == 1);
        if (this.status_selected) {
          this.$emit("changeDisplayStyle", this.status_selected);
        }
      }
    },
  },
  created() {
    this.fetchData();
  },
  // watch: {
  //   options(newValue) {
  //     this.options = newValue;
  //   },
  // },
};
</script>

<style>
.card_question {
  border-radius: 5px;
  border: 1px solid lightgray;
  margin: 0 0 15px 0;
  padding: 10px;
}

.question_line {
  height: 2px;
  background-color: #0000004a;
  border-radius: 25px;
  margin: 10px 0;
}
</style>
